import React from 'react';
import {Stack, Typography} from '@mui/material';
import NodeRenderer from './NodeRenderer';
import DisclosureMetadata from './DisclosureMetadata';
import {MentionHoverDismissProvider} from '../../../components/entityMentions/MentionHoverDismissContext';

/**
 * Component to render disclosure document content with disclosure-specific header
 */
const DisclosureContent = ({
                               content,
                               meta,
                               previewAuthors,
                               reportDoc,
                               version,
                               latestVersion,
                               referencesByMarkId,
                               referenceNumbers,
                               getReferenceNumber,
                               selectedAuthorId,
                               onAuthorClick,
                               onUserMentionClick,
                               onHashtagClick,
                           }) => {
    if (!content || content.type !== 'doc' || !Array.isArray(content.content)) {
        return null;
    }

    return (
        <MentionHoverDismissProvider>
        <Stack>
            <Typography
                variant="h4"
                component="h1"
                sx={{fontWeight: 900, letterSpacing: 1, textTransform: 'uppercase'}}
            >
                {meta?.title || reportDoc?.title || 'Untitled Disclosure'}
            </Typography>

            {/* Disclosure metadata */}
            <DisclosureMetadata
                meta={meta}
                previewAuthors={previewAuthors}
                reportDoc={reportDoc}
                version={version}
                latestVersion={latestVersion}
                selectedAuthorId={selectedAuthorId}
                onAuthorClick={onAuthorClick}
            />

            {/* Document content */}
            {content.content.map((node, i) => {
                return (
                    <NodeRenderer
                        key={node?.attrs?.uid || node?.attrs?.id || node?.id || i}
                        node={node}
                        idx={i}
                        referencesByMarkId={referencesByMarkId}
                        referenceNumbers={referenceNumbers}
                        getReferenceNumber={getReferenceNumber}
                        selectedAuthorId={selectedAuthorId}
                        onUserMentionClick={onUserMentionClick}
                        onHashtagClick={onHashtagClick}
                    />
                );
            })}
        </Stack>
        </MentionHoverDismissProvider>
    );
};

export default DisclosureContent;
